import { render } from "./AddProjectModal.vue?vue&type=template&id=2938a7f9&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=js"
export * from "./AddProjectModal.vue?vue&type=script&lang=js"

import "./AddProjectModal.vue?vue&type=style&index=0&id=2938a7f9&scoped=true&lang=css"
/* custom blocks */
import block0 from "./AddProjectModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2938a7f9"]])

export default __exports__